import { h } from '../index.js';
export const selectWorkflows = (state) => {
    const workflows = state.workflows;
    if (!h.hasData(workflows)) {
        return null;
    }
    return workflows.data;
};
export const selectWorkflowsIsLoading = (state) => {
    const workflowsState = state.workflows;
    return h.isLoading(workflowsState);
};
//# sourceMappingURL=selectors.js.map